export const PolarJServerModelContextPath = {
  AUTH: 'auth',
  USERACCOUNT: 'useraccounts',
  CRM_MESSAGES: 'crmmessages',
  AM_CATEGORYS: 'amcategorys',
  CITY_STATE_ZIPS: 'citystatezips',
  AM_MERCHANDISES: 'ammerchandises',
  AM_MERCHFAMILYS: 'ammerchfamilys',
  AM_KEYWORDS: 'amkeywords',
  AM_STORES: 'amstores',
  THE_CART: 'thecart',
  AM_FAVOURITES: 'amfavourites',
  ADDRESSS: 'addresss',
  AM_BUYERS: 'ambuyers',
  AM_SHOPPINFCARTS:'amshoppingcarts',
  AM_PLATFORM_LEGAL_DOCS: 'amplatformlegaldocuments',
  AM_PURCHASE_ORDERS: 'ampurchaseorders',
  CRM_AUTOMATIONS: 'crmautomations',
  SELECTION_DATAS:'selectiondatas',
  CRMFEED_SUBSCRIPTIONS:'crmfeedsubscriptions',
  USER_LOGIN_HISTORY:'userLoginHistory/create',
  USER_BROWSER_HISTORY: 'userPageBrowserHistory/create',
  AM_TRACK: 'Track',
}
